<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M4.85714 15.4286C6.4351 15.4286 7.71429 14.1494 7.71429 12.5715C7.71429 10.9935 6.4351 9.71436 4.85714 9.71436C3.27919 9.71436 2 10.9935 2 12.5715C2 14.1494 3.27919 15.4286 4.85714 15.4286Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.71484 12.5713V0.571289C8.5403 0.571289 9.35767 0.733874 10.1203 1.04976C10.8829 1.36564 11.5759 1.82865 12.1595 2.41233C12.7432 2.99602 13.2062 3.68895 13.522 4.45156C13.8379 5.21418 14.0006 6.03155 14.0006 6.857"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
